import ArtifactGroupType from "../base/ArtifactGroupType";

const ToolsOfTheFirstBuilders = {
  id: '97',
  name: 'Tools Of The First Builders',
  icon: 'ToolsOfTheFirstBuilders',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 10,
  gameId: 'ToolsOfTheFirstBuilders'
};

export default ToolsOfTheFirstBuilders;
